import { useMemo } from 'react';
import { useGroups } from '../../hooks/useGroups';
import SelectWithSearch from '../forms/form-elements/SelectWithSearch';
import { SelectOption } from '../../types';

type Props = {
  value: string;
  selectedOption: SelectOption | null;
  onChange: (value: string) => void;
  onSelectOption: (value: SelectOption) => void;
  placeholder?: string;
};

const GroupsSelect = ({
  value = '',
  onChange,
  onSelectOption,
  selectedOption,
  placeholder
}: Props) => {
  const { groups } = useGroups(1, 10, value);

  const options = useMemo(() => {
    return groups.map((g) => {
      return {
        label: g.name,
        value: g,
      };
    });
  }, [groups]);

  return (
    <SelectWithSearch
      selectedOption={selectedOption}
      onOptionSelect={onSelectOption}
      onQueryChange={onChange}
      query={value}
      options={options}
      placeholder={placeholder}
      skipInternalFiltering
    />
  );
};

export default GroupsSelect;
